import type { ApplicationStatus } from '../api/client';

const STATUS_CLASS: Record<ApplicationStatus, string> = {
  PROPOSED: 'badge',
  UNDER_REVIEW: 'badge badge-review',
  APPROVED: 'badge badge-open',
  REJECTED: 'badge badge-rejected',
  INTERVIEWING: 'badge badge-review',
  INTERVIEWED: 'badge badge-interviewed',
  HIRED: 'badge badge-hired',
};
const LABEL: Record<ApplicationStatus, string> = {
  PROPOSED: 'Proposed',
  UNDER_REVIEW: 'Under review',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  INTERVIEWING: 'Interviewing',
  INTERVIEWED: 'Interviewed',
  HIRED: 'Hired',
};

export default function StatusBadge({ status }: { status: ApplicationStatus }) {
  return <span className={STATUS_CLASS[status]}>{LABEL[status]}</span>;
}
